import UpdateBranding from "./UpdateBranding";

export default UpdateBranding;
